import * as allAnalyse from '../services/index';
export default {
  namespace: 'allAnalyse',
  state: {
    registerShopSort: [],
    buyShopSort: [],
    shoeSort: [],
    packetSort: [],
    memberSpread: [],
    cancellateUseRate: [],
    activityDetail: [],
    cancellateRate: [],
    registerDay: [],
    visitedDay: [],
    deadLineTime: {},
    newMemberRegister: [],
    jumpApplet: [],
    visitedMemberSall: [],
  },
  effects: {
    *registerShopSort({ payload: { values } }, { call, put }) {
      const response = yield call(allAnalyse.registerShopSort, {
        ...values,
      });
      yield put({
        type: 'save',
        payload: {
          registerShopSort: response?.data,
        },
      });
    },
    *buyShopSort({ payload: { values } }, { call, put }) {
      const response = yield call(allAnalyse.buyShopSort, {
        ...values,
      });
      yield put({
        type: 'save',
        payload: {
          buyShopSort: response?.data,
        },
      });
    },
    *shoeSort({ payload: { values } }, { call, put }) {
      const response = yield call(allAnalyse.shoeSort, {
        ...values,
      });
      yield put({
        type: 'save',
        payload: {
          shoeSort: response?.data,
        },
      });
    },
    *packetSort({ payload: { values } }, { call, put }) {
      const response = yield call(allAnalyse.packetSort, {
        ...values,
      });
      yield put({
        type: 'save',
        payload: {
          packetSort: response?.data,
        },
      });
    },
    *memberSpread({ payload: { values } }, { call, put }) {
      const response = yield call(allAnalyse.memberSpread, {
        ...values,
      });
      yield put({
        type: 'save',
        payload: {
          memberSpread: response?.data,
        },
      });
    },
    *cancellateUseRate({ payload: { values } }, { call, put }) {
      const response = yield call(allAnalyse.cancellateUseRate, {
        ...values,
      });
      yield put({
        type: 'save',
        payload: {
          cancellateUseRate: response?.data,
        },
      });
    },
    *activityDetail({ payload: { values } }, { call, put }) {
      const response = yield call(allAnalyse.activityDetail, {
        ...values,
      });
      yield put({
        type: 'save',
        payload: {
          activityDetail: response?.data,
        },
      });
    },
    *cancellateRate({ payload: { values } }, { call, put }) {
      const response = yield call(allAnalyse.cancellateRate, {
        ...values,
      });
      yield put({
        type: 'save',
        payload: {
          cancellateRate: response?.data,
        },
      });
    },
    *registerDay({ payload: { values } }, { call, put }) {
      const response = yield call(allAnalyse.registerDay, {
        ...values,
      });
      yield put({
        type: 'save',
        payload: {
          registerDay: response?.data,
        },
      });
    },
    *visitedDay({ payload: { values } }, { call, put }) {
      const response = yield call(allAnalyse.visitedDay, {
        ...values,
      });
      yield put({
        type: 'save',
        payload: {
          visitedDay: response?.data,
        },
      });
    },
    *deadLineTime({ payload: { values } }, { call, put }) {
      const response = yield call(allAnalyse.deadLineTime, {
        ...values,
      });
      yield put({
        type: 'save',
        payload: {
          deadLineTime: response?.data,
        },
      });
    },
    *newMemberRegister({ payload: { values } }, { call, put }) {
      const response = yield call(allAnalyse.newMemberRegister, {
        ...values,
      });
      yield put({
        type: 'save',
        payload: {
          newMemberRegister: response?.data,
        },
      });
    },
    *jumpApplet({ payload: { values } }, { call, put }) {
      const response = yield call(allAnalyse.jumpApplet, {
        ...values,
      });
      yield put({
        type: 'save',
        payload: {
          jumpApplet: response?.data,
        },
      });
    },
    *visitedMemberSall({ payload: { values } }, { call, put }) {
      const response = yield call(allAnalyse.visitedMemberSall, {
        ...values,
      });
      yield put({
        type: 'save',
        payload: {
          visitedMemberSall: response?.data,
        },
      });
    },
  },
  reducers: {
    save(state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },
  },
};
